
import { ref, defineComponent, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import _ from "lodash";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import ExportCustomerModal from "@/components/modals/forms/ExportCustomerModal.vue";
import AddAdminModal from "@/components/modals/forms/AddAdminModal.vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { onBeforeRouteUpdate, useRoute } from "vue-router";
import * as Yup from "yup";

interface Buscador {
  estado?: number;
  factura?: number;
  empresaId?: number;
  fechaInicio?: Date;
  fechaTermino?: Date;
  proveedorId: number;
}

export default defineComponent({
  name: "kt-customer-list",
  components: {
    DataTable,
    Column,
    ExportCustomerModal,
    AddAdminModal,
  },
  setup() {
    const router = useRouter();
    const submitButton1 = ref<HTMLElement | null>(null);
    const store = useStore();
    onMounted(() => {
      setCurrentPageBreadcrumbs("Usuarios", ["Página", "Dashboard"]);
      buscarUsuarios();
    });
    onBeforeRouteUpdate((to, from, next) => {
      buscarUsuarios();
      next();
    });
    const buscador = ref<Buscador>({
      proveedorId: store.getters.currentUser.id,
    });
    const formatDate = (value) => {
      value = new Date(value);
      return value.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    };
    const formatCurrency = (value) => {
      return value.toLocaleString("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: "CLP",
      });
    };
    const dataexport = () => {
      const newJson = store.getters.allUsuarios.map((rec) => {
        return {
          "Rut Proveedor": rec.rutProveedor,
          Email: rec.email,
          "Nombre Contacto": rec.nombreCompleto,
          Teléfono: rec.telefono,
          "F. Creación": formatDate(rec.fechaCreacion),
          Estado: rec.activo ? "Vigente" : "No Vigente",
        };
      });
      return newJson;
    };

    const exportExcel = () => {
      import("xlsx").then((xlsx) => {
        const worksheet = xlsx.utils.json_to_sheet(dataexport());
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer, "usuarios");
      });
    };
    const saveAsExcelFile = (buffer, fileName) => {
      import("file-saver").then((FileSaver) => {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        FileSaver.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      });
    };
    const buscadorValidator = Yup.object().shape({});
    const buscarUsuarios = () => {
      store
        .dispatch(Actions.GET_USUARIOS_ADMINISTRADORES)
        .then(() => {
          loading.value = false;
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getUsuarioErrors);
        });
    };

    const currentUser = computed(() => {
      return store.getters.currentUser;
    });
    const allUsuarios = computed(() => {
      return store.getters.allUsuarios;
    });
    const editUsuario = (usuario) => {
      router.push({
        name: "apps-admins-details",
        params: { id: usuario.tokenUsuario },
      });
    };
    const filters1 = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const search = ref(null);
    const selectedUsuarios = ref(null);
    const loading = ref(true);
    return {
      filters1,
      buscador,
      selectedUsuarios,
      loading,
      buscadorValidator,
      buscarUsuarios,
      submitButton1,
      editUsuario,
      allUsuarios,
      exportExcel,
      formatDate,
      formatCurrency,
    };
  },
});
